module.exports = __webpack_public_path__ + "static/media/RalfiMade.3983680a.png";